// @flow

import type {
  TransportType,
  PageViewType,
  EventType,
  GoalType,
  ConversionType
} from '../';

type GoogleAnalyticsOptions = {
  trackingId: string
};

export default function configure(
  options: GoogleAnalyticsOptions
): TransportType {
  const { trackingId } = options;

  if (!trackingId) {
    return {};
  }

  const doc = document;
  const win = window;

  if (!win.ga) {
    // $FlowFixMe
    (function(i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      win,
      doc,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    );
  } else if (__DEV__) {
    console.warn('[trackr] Google Analytics has already been loading');
  }

  win.ga('create', trackingId, 'auto');
  // ga('require', 'displayfeatures');
  // ga('require', 'ec');

  return {
    pageview({ location }: PageViewType): void {
      win.ga('set', 'page', `${location.pathname}${location.search}`);
      win.ga('send', 'pageview');
    },
    event({ category, action, label = '', value = 0 }: EventType): void {
      win.ga('send', 'event', category, action, label, value);
    },
    goal(options: GoalType): void {
      // CUSTOM CODE
      if (typeof options === 'string') {
        const args = options.split('-');
        if (args.length === 2 || args.length === 3) {
          win.ga('send', 'event', ...args);
        }
      }
      if (typeof options === 'object') {
        // ga('send', 'event', category, action, label, value);
      }
    },
    conversion(data: ConversionType): void {
      const {
        ref: id,
        affiliation,
        product: { name, code: sku, category },
        revenue = 0,
        fee = 0,
        tax = 0
      } = data;

      win.ga('require', 'ecommerce');
      win.ga('ecommerce:addTransaction', {
        id,
        affiliation,
        revenue: revenue.toFixed(2),
        shipping: fee.toFixed(2),
        tax: tax.toFixed(2)
      });
      win.ga('ecommerce:addItem', {
        id,
        name,
        sku,
        category,
        price: revenue.toFixed(2)
      });
      win.ga('ecommerce:send');
    }
  };
}
